import { useQuery } from "@tanstack/react-query";
import { FileText } from "lucide-react";
import { PageBreadcrumbs } from "@/components/shared/page-breadcrumbs";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { apiGet } from "@/lib/api-client";
import { configKeys } from "@/lib/query";
import { paramUploadPdfSchema } from "@/schemas/config";

const MAINTENANCE_HELP =
  "In the event that the schedule which runs on the final day of each month is unsuccessful, enter the desired period and the system will take a backup of the current team structure for that period.";

export function ClaimTeamHelpPage() {
  const helpQuery = useQuery({
    queryKey: configKeys.paramUploadPdf,
    queryFn: () => apiGet("/api/config/param/upload-pdf", paramUploadPdfSchema),
  });

  return (
    <div className="space-y-6">
      <PageBreadcrumbs current="Claim Team Help" />
      <div className="rounded-md border bg-card p-4">
        <h1 className="font-display text-3xl font-bold">Claim Team Help</h1>
        <p className="mt-1 text-muted-foreground">Help documentation for claim team maintenance.</p>
      </div>

      <Card>
        <CardHeader className="pb-3">
          <h3 className="font-semibold">Claim Team Maintenance</h3>
        </CardHeader>
        <CardContent>
          <p className="whitespace-pre-wrap text-sm leading-relaxed">{MAINTENANCE_HELP}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-3">
          <h3 className="font-semibold">Claim Team History Help PDF</h3>
        </CardHeader>
        <CardContent>
          {helpQuery.isLoading && <div className="h-10 animate-pulse rounded bg-muted" />}
          {helpQuery.isError && (
            <p className="text-sm text-destructive">
              Failed to load help file.{" "}
              <button type="button" className="underline" onClick={() => helpQuery.refetch()}>
                Retry
              </button>
            </p>
          )}
          {helpQuery.data &&
            (helpQuery.data.claimTeamHistoryHelpFile ? (
              <a
                href={helpQuery.data.claimTeamHistoryHelpFile}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-primary hover:underline"
              >
                <FileText className="size-4" />
                {helpQuery.data.claimTeamHistoryHelpFileName ||
                  helpQuery.data.claimTeamHistoryHelpFile}
              </a>
            ) : (
              <p className="text-sm text-muted-foreground">
                No help file configured.{" "}
                {helpQuery.data.claimTeamHistoryHelpFileName && (
                  <span>Expected: {helpQuery.data.claimTeamHistoryHelpFileName}</span>
                )}
              </p>
            ))}
        </CardContent>
      </Card>
    </div>
  );
}
